<template>
  <div>
    <CaseTab :predmet_info="predmet_info" :current_tab="'Planer'" />
    <div class="case-planer">
      <div class="planer-column">
        <div class="planer-column-title">U pripremi</div>
        <div class="planer-add-task section" @click="openPopup(0, null)" v-if="is_permission_inside('project.task.create')"><span>+</span> Dodaj zadatak</div>
        <draggable @change="checkMove(0, $event)" v-model="to_do_list" :animation="200" ghost-class="ghost-card"
          group="tasks" style="min-height:200px;">
          <div @click="openPopup(0, task)"
            v-for="(task, key) in see_more_todo ? to_do_list.slice(0, max_len_rest) : to_do_list" :key="key"
            class="planer-task section">
            <div class="planer-mark-txt">
              <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>

              <div :class="['task-checkbox', 'popup-check']" @click.stop="finishTask(task)"></div>
              <div class="planer-task-txt">{{ task.title }}</div>
            </div>
            <div v-if="task.end_date_time != null && task.end_date_time != ''" class="planer-task-deadline">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <g>
                  <g>
                    <path
                      d="M27.632 5.472v18.951a3.238 3.238 0 0 1-3.238 3.23H3.238A3.238 3.238 0 0 1 0 24.423V5.472a3.238 3.238 0 0 1 3.238-3.23h1.295V.087h2.16V2.24H20.94V.088h2.159V2.24h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H2.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H23.1V6.55h-2.16V4.395H6.693V6.55H4.533V4.395H3.238a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM4.102 12.47H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zM4.102 21.085H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z" />
                  </g>
                </g>
              </svg>
              {{ getDatum(task.end_date_time) }}
            </div>
          </div>
        </draggable>
        <div v-if="to_do_list.length > max_len_rest" @click="see_more_todo = !see_more_todo;" class="see-more">
          <div class="section-divider"></div>
          <div class="see-more-wrapper" v-if="see_more_todo">
            <span>Prikaži više</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.6763 0.27958C14.1079 0.652353 14.1079 1.25674 13.6763 1.62951L7.78154 6.72042C7.34991 7.09319 6.65009 7.09319 6.21846 6.72042L0.323725 1.62951C-0.107907 1.25674 -0.107907 0.652353 0.323725 0.279579C0.755356 -0.0931939 1.45517 -0.0931938 1.8868 0.279579L7 4.69552L12.1132 0.27958C12.5448 -0.0931934 13.2446 -0.0931933 13.6763 0.27958Z"
                fill="#59596E" />
            </svg>
          </div>
          <div class="see-more-wrapper" v-if="!see_more_todo">
            <span>Prikaži manje</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.323724 6.72042C-0.107908 6.34765 -0.107908 5.74326 0.323724 5.37049L6.21846 0.279579C6.65009 -0.093194 7.34991 -0.093194 7.78154 0.279579L13.6763 5.37049C14.1079 5.74326 14.1079 6.34765 13.6763 6.72042C13.2446 7.09319 12.5448 7.09319 12.1132 6.72042L7 2.30448L1.8868 6.72042C1.45517 7.09319 0.755356 7.09319 0.323724 6.72042Z"
                fill="#59596E" />
            </svg>
          </div>
        </div>
      </div>
      <div class="planer-column">
        <div class="planer-column-title">U tijeku</div>
        <div class="planer-add-task section" @click="openPopup(50, null)" v-if="is_permission_inside('project.task.create')"><span>+</span> Dodaj zadatak</div>
        <draggable @change="checkMove(50, $event)" v-model="in_progress_list" :animation="200" ghost-class="ghost-card"
          group="tasks" style="min-height:200px;">
          <div @click="openPopup(50, task)"
            v-for="(task, key) in  see_more_prog ? in_progress_list.slice(0, max_len_rest) : in_progress_list" :key="key"
            class="planer-task section">
            <div class="planer-mark-txt">
              <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>

              <div :class="['task-checkbox', 'popup-check']" @click.stop="finishTask(task)"></div>
              <div class="planer-task-txt">{{ task.title }}</div>
            </div>
            <div v-if="task.end_date_time != null && task.end_date_time != ''" class="planer-task-deadline">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <g>
                  <g>
                    <path
                      d="M27.632 5.472v18.951a3.238 3.238 0 0 1-3.238 3.23H3.238A3.238 3.238 0 0 1 0 24.423V5.472a3.238 3.238 0 0 1 3.238-3.23h1.295V.087h2.16V2.24H20.94V.088h2.159V2.24h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H2.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H23.1V6.55h-2.16V4.395H6.693V6.55H4.533V4.395H3.238a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM4.102 12.47H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zM4.102 21.085H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z" />
                  </g>
                </g>
              </svg>
              {{ getDatum(task.end_date_time) }}
            </div>
          </div>
        </draggable>
        <div v-if="in_progress_list.length > max_len_rest" @click="see_more_prog = !see_more_prog;" class="see-more">
          <div class="section-divider"></div>
          <div class="see-more-wrapper" v-if="see_more_prog">
            <span>Prikaži više</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.6763 0.27958C14.1079 0.652353 14.1079 1.25674 13.6763 1.62951L7.78154 6.72042C7.34991 7.09319 6.65009 7.09319 6.21846 6.72042L0.323725 1.62951C-0.107907 1.25674 -0.107907 0.652353 0.323725 0.279579C0.755356 -0.0931939 1.45517 -0.0931938 1.8868 0.279579L7 4.69552L12.1132 0.27958C12.5448 -0.0931934 13.2446 -0.0931933 13.6763 0.27958Z"
                fill="#59596E" />
            </svg>
          </div>
          <div class="see-more-wrapper" v-if="!see_more_prog">
            <span>Prikaži manje</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.323724 6.72042C-0.107908 6.34765 -0.107908 5.74326 0.323724 5.37049L6.21846 0.279579C6.65009 -0.093194 7.34991 -0.093194 7.78154 0.279579L13.6763 5.37049C14.1079 5.74326 14.1079 6.34765 13.6763 6.72042C13.2446 7.09319 12.5448 7.09319 12.1132 6.72042L7 2.30448L1.8868 6.72042C1.45517 7.09319 0.755356 7.09319 0.323724 6.72042Z"
                fill="#59596E" />
            </svg>
          </div>
        </div>
      </div>
      <div class="planer-column">
        <div class="planer-column-title">Riješeno</div>
        <div class="planer-add-task section" @click="openPopup(100, null)" v-if="is_permission_inside('project.task.create')"><span>+</span> Dodaj zadatak</div>
        <draggable @change="checkMove(100, $event)" v-model="finished_list" :animation="200" ghost-class="ghost-card"
          group="tasks" style="min-height:200px;">
          <div @click="openPopup(100, task)"
            v-for="(task, key) in see_more_fin ? finished_list.slice(0, max_len_fin) : finished_list " :key="key"
            class="planer-task task-done section">
            <div class="planer-mark-txt">
              <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>

              <div :class="['task-checkbox', 'popup-check', 'active']" @click.stop="unFinishTask(task)">
                <div class="check"></div>
              </div>
              <div class="planer-task-txt">{{ task.title }}</div>
            </div>
          </div>
        </draggable>
        <div v-if="finished_list.length > max_len_fin" @click="see_more_fin = !see_more_fin;" class="see-more">
          <div class="section-divider"></div>
          <div class="see-more-wrapper" v-if="see_more_fin">
            <span>Prikaži više</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.6763 0.27958C14.1079 0.652353 14.1079 1.25674 13.6763 1.62951L7.78154 6.72042C7.34991 7.09319 6.65009 7.09319 6.21846 6.72042L0.323725 1.62951C-0.107907 1.25674 -0.107907 0.652353 0.323725 0.279579C0.755356 -0.0931939 1.45517 -0.0931938 1.8868 0.279579L7 4.69552L12.1132 0.27958C12.5448 -0.0931934 13.2446 -0.0931933 13.6763 0.27958Z"
                fill="#59596E" />
            </svg>
          </div>
          <div class="see-more-wrapper" v-if="!see_more_fin">
            <span>Prikaži manje</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.323724 6.72042C-0.107908 6.34765 -0.107908 5.74326 0.323724 5.37049L6.21846 0.279579C6.65009 -0.093194 7.34991 -0.093194 7.78154 0.279579L13.6763 5.37049C14.1079 5.74326 14.1079 6.34765 13.6763 6.72042C13.2446 7.09319 12.5448 7.09319 12.1132 6.72042L7 2.30448L1.8868 6.72042C1.45517 7.09319 0.755356 7.09319 0.323724 6.72042Z"
                fill="#59596E" />
            </svg>
          </div>
        </div>
      </div>
      <div class="vertical-divider-big"></div>
      <div class="planer-column archived-column">
        <div class="planer-column-title">Arhivirano</div>
        <draggable @change="checkMove(-1, $event)" v-model="archived_list" :animation="200" ghost-class="ghost-card"
          group="tasks" style="min-height:200px;">
          <div v-for="(task, key) in see_more_arch ? archived_list.slice(0, max_len_arch) : archived_list"
            @click="openPopup(task.planner_buckets_status.id, task)" :key="key" class="archived-task">
            <div class="status-svg-wrapper">
              <svg v-if="task.planner_buckets_status.id == 100" xmlns="http://www.w3.org/2000/svg" width="10" height="8"
                viewBox="0 0 10 8" fill="none">
                <path d="M1 4.32499L3.65936 6.98323L8.97585 1.66675" stroke="#9999A6" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <svg style="margin:-3px -7px 0 -7px;" v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none">
                <path d="M8.46409 15.5354L15.5352 8.46436" stroke="#9999A6" stroke-width="1.5" stroke-linecap="round" />
                <path d="M8.46409 8.46458L15.5352 15.5356" stroke="#9999A6" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
            <div class="planer-mark-txt">
              <div class="planer-task-txt">{{ task.title }}</div>
            </div>
          </div>
        </draggable>
        <div v-if="archived_list.length > max_len_arch" @click="see_more_arch = !see_more_arch;" class="see-more">
          <div class="section-divider"></div>
          <div class="see-more-wrapper" v-if="see_more_arch">
            <span>Prikaži više</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.6763 0.27958C14.1079 0.652353 14.1079 1.25674 13.6763 1.62951L7.78154 6.72042C7.34991 7.09319 6.65009 7.09319 6.21846 6.72042L0.323725 1.62951C-0.107907 1.25674 -0.107907 0.652353 0.323725 0.279579C0.755356 -0.0931939 1.45517 -0.0931938 1.8868 0.279579L7 4.69552L12.1132 0.27958C12.5448 -0.0931934 13.2446 -0.0931933 13.6763 0.27958Z"
                fill="#59596E" />
            </svg>
          </div>
          <div class="see-more-wrapper" v-if="!see_more_arch">
            <span>Prikaži manje</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.323724 6.72042C-0.107908 6.34765 -0.107908 5.74326 0.323724 5.37049L6.21846 0.279579C6.65009 -0.093194 7.34991 -0.093194 7.78154 0.279579L13.6763 5.37049C14.1079 5.74326 14.1079 6.34765 13.6763 6.72042C13.2446 7.09319 12.5448 7.09319 12.1132 6.72042L7 2.30448L1.8868 6.72042C1.45517 7.09319 0.755356 7.09319 0.323724 6.72042Z"
                fill="#59596E" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <ProjectTask ref="projectTask" :is_edit="is_edit" :attachment_root="attachment_root" :group_url="group_url"
      :init_team="team_list_initial" :accessToken="accessToken" :statusi_dogadaja="statusi_dogadaja"
      :event_importance_list="event_importance_list" :team_members="team_list" @update_team="update_team"
      @refreshTeam="refreshTeam" />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import auth from "@/services/auth";
import ProjTab from "@/components/projectComponents/ProjTab.vue"
import projCaller from "@/apiCallers/promise_handler_db/projects"
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import ProjectTask from '@/components/projectComponents/ProjectTask'
import ms_calendar from "@/apiCallers/calendarSharepoint";
import permissioner from "@/services/permissioner.js"
import gsap from 'gsap';
import $ from 'jquery';
import moment from "moment";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import {getCaseData} from "@/router/case/handler"

export default {
  components: {
    draggable,
    ProjTab,
    CaseTab,
    ProjectTask
  },
  data() {
    return {
      accessToken: "",
      predmet_info: {broj_predmeta:''},
      statusi_dogadaja: [],
      event_importance_list: [],
      team_list: [],
      team_list_initial: [],
      group_url: "",
      all_tasks: [],
      sioVar: {
        type: {},
        required: false,
        default: null,
      },

      mapped_project_permission : [],
      to_do_list: [],
      in_progress_list: [],
      finished_list: [],
      archived_list: [],
      attachment_root: '',
      is_edit: false,
      temp_archived: [],
      see_more_arch: true,
      see_more_fin: true,
      see_more_prog: true,
      see_more_todo: true,
      max_len_arch: 8,
      max_len_fin: 5,
      max_len_rest: 4
    };
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("update planner", async (data) => { 
          this.setToBuckets(data)
        });
      }
    },
    "$store.state.sioVar": function () {
      if (this.$store.state.sioVar != null) {
        this.sioVar = this.$store.state.sioVar
      }
    }
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    // await permissioner.checkUserInfo();
    // if(!this.is_permission_inside("project.edit"))
    //   this.$router.push("/projects/" + this.$route.params.uid + "/participants");

      await getCaseData(this.$route.params.uid).then(async (response) => {
        let all_together = response
        this.predmet_info = all_together;
        this.group_url = this.predmet_info.group_url;
        this.attachment_root = this.predmet_info.root_attachment;
        this.team_list = this.predmet_info.predmet_odvjetnik_connector.map((el) => {
          return {
            'is_fiz': true,
            'link': el.odvjetnik.uid,
            'value': el.odvjetnik.ime + ' ' + el.odvjetnik.prezime
          }
        })
        this.team_list_initial = [...this.team_list]
        console.log(this.predmet_info);
      });
    await this.refreshTasks();
    await ms_calendar.getEventBucketStatus().then((resp) => {
      resp.data.map((ev) => this.statusi_dogadaja.push({ naziv: ev.name, id: ev.value }));
    });
    await ms_calendar.getImportanceTypes().then((resp) => {
      this.event_importance_list = resp.data;
    });
    this.sioVar = this.$store.state.sioVar
  },
  methods: {
    is_permission_inside(wanted_permission) {
    //  return permissioner.check_project_permission(wanted_permission)
     return true;
    },
    async finishTask(task) {
      await projCaller.updateProjectProgress(task.uid, 100, this.team_list_initial, this.$route.params.uid, true).then((resp) => {
        console.log("TASK STATUS UPDATED");
      })
    },
    async unFinishTask(task) {
      await projCaller.updateProjectProgress(task.uid, 0, this.team_list_initial, this.$route.params.uid, true).then((resp) => {
        console.log("TASK STATUS UPDATED");
      })
    },
    async checkMove(progress, evt) {
      if (evt.added != undefined) {
        //napravi refresh
        await projCaller.updateProjectProgress(evt.added.element.uid, progress, this.team_list_initial, this.$route.params.uid, true).then((resp) => {
          console.log("TASK STATUS UPDATED");
        })
      }
    },
    openPopup(progress, task) {
      this.$store.state.project_task_progress = progress;
      this.$store.state.edit_data = task;
      if (this.$store.state.edit_data != null) {
        this.is_edit = true;
      }
      else {
        this.is_edit = false;
      }
      gsap.to(".project-entry", 0, { display: 'block' })
    },
    update_team(list) {
      this.team_list = list;
    },
    refreshTeam() {
      this.team_list = [...this.team_list_initial];
    },
    getDatum(date) {
      if (date != null && date != "") {
        return moment(date).format("DD.MM.YYYY");
      }
      return ""
    },
    setToBuckets(data) {
      this.all_tasks = data;
      this.to_do_list = this.all_tasks.filter((task) => task.status_id == 0 && !task.is_archived)
      this.in_progress_list = this.all_tasks.filter((task) => task.status_id == 50 && !task.is_archived)
      this.finished_list = this.all_tasks.filter((task) => task.status_id == 100 && !task.is_archived).sort(function (a, b) {
        return new Date(b.finishing_timestamp) - new Date(a.finishing_timestamp);
      })
      this.archived_list = this.all_tasks.filter(task => task.is_archived).sort((a,b)=>a.status_id-b.status_id);
    },
    async refreshTasks() {
      await predmet_hand.getCaseTasks(this.$route.params.uid).then((resp) => {
        this.setToBuckets(resp.data)
      });
    },
  },
};
</script>

<style>
</style>